import { useLocation } from "react-router-dom";

import { capitalizeLink } from "../../_helpers/utility-methods";

export const PageCaptionImage = ({imageUrl, caption,caption1}) => {

    const { pathname } = useLocation();

    return (
        <div 
            className="page-pic-box"
            style={{backgroundImage:`url(${imageUrl})`}}
        >
            <div className="page-pic-bg">
                <div className="pre-txt" />
                <div className="page-bg-text">
                    <p>{caption}</p>
                   {caption1 && <p>{caption1}</p>}
                    <div>
                        <button className="path-btn">
                            <a href="/">Home/</a>{capitalizeLink(pathname)}
                        </button>
                    </div>
                </div>
                <div className="pre-txt" />
            </div>
        </div>
    )
}